import messages from "@smartmixin/i18n/dist/translations/ko.json";

export default messages;
